import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        button: {
            whiteSpace: 'nowrap',
            minWidth: 180,
        },
    }
})

export default useStyles
